export default [
    {
        path: '/partners',
        name: 'partners',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Users/Partners.vue')
    }
]